<template>
    <div v-if="criteresRecherche" class="tableWithPerPageSelection">
      <div class="entete border-entete">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">{{ $t('listeEcheancePaiement.title')}}</h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="level mgt-20px">
        <div class="level-left">
          <div class="columns">
            <div class="column is-narrow">
              <selecteur-action
                @handleAction="handleAction"
                :options='actions'
                :placeholder='$t("general.placeHolder.groupedAction")'
                :titleButton="'general.button.apply'"
                :elementsSelectionnes="getAllEcheancesAPayerSelected().length > 0"
              ></selecteur-action>
            </div>
            <form @submit.prevent="recherche()" class="column is-3">
              <b-input :placeholder="$t('listeEcheancePaiement.actions.search')"
                       type="search"
                       icon="magnify"
                       v-model="criteresRecherche.auto">
              </b-input>
            </form>
            <div class="column is-narrow">
              <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">{{$t('general.button.filtre')}}
                  <label class="has-text-weight-bold"
                        :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span @click="reinitialiserFiltre()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
            <div class='column is-narrow'>
              <date-picker :dates='criteresRecherche.datesMouvement'
                           :triggerSearchEveryTime="false"
                           :updateEndDateAtChangeStartDate="false"
                           @recherche="recherche"/>
            </div>
          </div>
        </div>
        <div class="level-right columns">
          <div class="column is-narrow">
            <exportExcelButton
              :perm="permsEcheancePaiement.exporter"
              :query="exportExcelQuery"/>
          </div>
          <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
      <div class="level-right">
        <div class="lien mgb-20px has-text-right is-cursor-pointer"
            @click="displayOrMasquerEcheanceAnt()">
          {{ displayEcheancesAnt
          ? $t('listeEcheancePaiement.masquerEchAnt')
          : $t('listeEcheancePaiement.displayEchAnt',
            {total: totalEcheancesBeforeNow >= 0
                ? totalEcheancesBeforeNow : $t('general.enCoursCalcul') }) }}
        </div>
      </div>
      <v-server-table
        url="" :columns="columns" :options="options" :ref="referenceTable"
        @loaded="finLoading" @loading="debutLoading"
        v-if="startArrayRendering && mountedLoadingEnd"
        class="overflow-x-auto">
        <template slot='afterTable'>
          <table-items-in-view @input="$refs[referenceTable].setLimit($event)"
                               :perPage="resultPerPage"/>
        </template>
        <div slot="selected" slot-scope="props" class="has-text-centered">
          <b-checkbox v-model="props.row.selected"
                      :value="props.row"
                      :disabled="props.row.resteALettrer === 0">
          </b-checkbox>
        </div>
        <div slot="factureCode" slot-scope="props">
          <router-link-blank :to="{ name: 'c.bodac.factures',
              params: {id: props.row.factureId}}"
              :message="props.row.factureCode">
          </router-link-blank>
          {{  }}
        </div>
        <div slot="dateFacture" slot-scope="props">
          {{ props.row.dateFacture | formatDate}}
        </div>
        <div slot="payeur" slot-scope="props">
          <router-link-blank :to="{ name: 'c.bodac.clients/contacts-client',
            params: {id: props.row.payeurId}}"
              :message="props.row.payeur">
          </router-link-blank>
        </div>
        <div slot="compteComptable" slot-scope="props">
          {{ props.row.compteComptable }}
        </div>
        <div slot="dateMouvement" slot-scope="props">
          {{ props.row.dateMouvement | formatDate }}
          <div v-if="props.row.commentaire " class="is-pulled-right">
            <b-tooltip
                    multiline
                    type="is-warning"
                    position="is-bottom">
              <template v-slot:content>
                <div class="is-pre">{{props.row.commentaire}}</div>
              </template>
              <b-icon icon="alert" custom-size="mdi-24px" type="is-warning">
              </b-icon>
            </b-tooltip>
          </div>
        </div>
        <div slot="montantTTC" slot-scope="props" class="has-text-right">
          {{ func.formatDevise(props.row.montantTTC) }}
        </div>
        <div slot="resteALettrer" slot-scope="props" class="has-text-right">
          {{ func.formatDevise(props.row.resteALettrer) }}
        </div>
        <div slot="modeReglementLibelle" slot-scope="props">
          {{ props.row.modeReglementLibelle }}
        </div>
        <div slot="commercial" slot-scope="props">
          {{ props.row.commercial }}
        </div>
        <div slot="assistant" slot-scope="props">
          {{ props.row.assistant }}
        </div>
        <div slot="etat" slot-scope="props">
          {{ getEtatEcheance(props.row.resteALettrer) }}
        </div>
        <div slot="referenceUniqueMandat" slot-scope="props">
          {{ props.row.referenceUniqueMandat }}
        </div>
        <div slot="dateSignatureMandat" slot-scope="props">
          {{ props.row.dateSignatureMandat | formatDate }}
        </div>
        <div slot="agence" slot-scope="props">
          {{ getAgenceLibelle(props.row.agenceId) }}
        </div>
        <div slot="iban" slot-scope="props">
          <span class="is-pre">
            {{ibanFormat(props.row.rib.iban)}}
          </span>
        </div>
      </v-server-table>
      <transition name="custom-classes-transition"
                  enter-active-class="animate__animated animate__slideInRight"
                  leave-active-class="animate__animated animate__slideOutRight" :duration="10">
        <div class="componentBrief" v-show="showFiltre === true">
          <filtre-liste-echeance-paiement ref="filtreListeEcheancePaiement"
                                          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
                                          @recherche="makeRechercheFilter"/>
        </div>
      </transition>
      <b-modal v-model="popUpCreationRemiseBancaire"
               has-modal-card>
        <creation-remise-bancaire :echeances="echeancesAPayerAModifier"
                               @refresh="closeAndSearch"></creation-remise-bancaire>
      </b-modal>
      <b-modal v-model="popUpReplanification"
               has-modal-card>
        <replanification-echeance-a-payer :echeancesAPayer="echeancesAPayerAModifier"
                                          @replanificationOk="closePopUpAndInformUser">
        </replanification-echeance-a-payer>
      </b-modal>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import TableItemsInView from '@/components/general/TableItemsInView';
import datePicker from '@/components/general/datePicker';
import { NO_PER_PAGE_VALUE, SORT_ICON, TEXTS } from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import {
  RESULTS_PER_PAGE_ECHEANCES,
  EXPORT_EXCEL_TYPE_ECHEANCES,
  ACTION_CREER_REMISE_BANCAIRE,
  ACTION_REPLANNIFER,
} from '@/configuration/echeancePaiement/echeancePaiementConf';
import {
  SET_DATES_ECHEANCES_SAVE,
  SET_DISPLAY_ECHECHEANCES_ANT,
} from '@/store/modules/baux/echeancesAPayer-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import { ECHEANCIER_PAIEMENT } from '@/configuration/permissionsBodacConf';
import AppBreadcrumb from '@/components/general/breadcrumb';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import snackBarSuccess from '@/services/general/snackbar/snackBarSuccess';
import { formatDevise } from '@/services/general/filters/formatDevise';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import filtreListeEcheancePaiement from '@/components/echeancePaiement/filtreListeEcheancePaiement';
import creationRemiseBancaire from '@/components/echeancePaiement/p_creationRemiseBancaire';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import selecteurAction from '@/components/general/selecteurAction';
import ibanFormater from '@/services/general/ibanFormater';
import replanificationEcheanceAPayer from '@/components/bodac/echeancesAPayer/p_replanificationEcheanceAPayer';
import { REFERENCE_TABLE_ECHEANCE_PAIEMENT } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';

const EcheancesAPayer = createNamespacedHelpers('echeancePaiement');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      loadingComponent: null,
      unsubscribeValue: null,
      showFiltre: false,
      permsEcheancePaiement: ECHEANCIER_PAIEMENT,
      resultPerPage: RESULTS_PER_PAGE_ECHEANCES,
      actions: [
        { action: ACTION_CREER_REMISE_BANCAIRE, translation: 'listeEcheancePaiement.actions.creerRemiseBancaire' },
        { action: ACTION_REPLANNIFER, translation: 'listeEcheancesAPayer.actions.replanifier' },
      ],
      popUpCreationRemiseBancaire: false,
      echeancesAPayerAModifier: [],
      popUpReplanification: false,
      referenceTable: REFERENCE_TABLE_ECHEANCE_PAIEMENT,
      func: {
        formatDevise,
      },
      mountedLoadingEnd: false,
      startArrayRendering: false,
    };
  },
  components: {
    TableItemsInView,
    datePicker,
    AppBreadcrumb,
    routerLinkBlank,
    filtreListeEcheancePaiement,
    selecteurAction,
    creationRemiseBancaire,
    replanificationEcheanceAPayer,
    parametrageTable,
    exportExcelButton,
  },
  methods: {
    ...EcheancesAPayer.mapActions({
      loadEcheancesAPayer: 'loadEcheancePaiement',
    }),
    ...EcheancesAPayer.mapMutations({
      setDisplayEcheanceAnt: SET_DISPLAY_ECHECHEANCES_ANT,
      setDatesEcheancesSave: SET_DATES_ECHEANCES_SAVE,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ibanFormat(value) {
      return ibanFormater(value);
    },
    getAllEcheancesAPayerSelected() {
      return this.echeancesAPayer.filter((el) => {
        return el.selected;
      });
    },
    deselectAll() {
      this.echeancesAPayer.forEach((el) => {
        el.selected = false;
      });
    },
    selectAll() {
      const select = !this.allEcheancesAPayerSelected;
      this.echeancesAPayer.forEach((el) => {
        el.selected = select && el.resteALettrer !== 0;
      });
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeEcheancePaiement.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesIds.length === 0) return;
      const agencesIds = [];
      this.criteresRecherche.agencesIds.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesIds.push(id);
      });
      this.criteresRecherche.agencesIds = agencesIds;
      this.$refs[this.referenceTable].setPage(1);
    },
    async reinitialiserFiltre() {
      this.setDisplayEcheanceAnt(false);
      await this.$refs.filtreListeEcheancePaiement.initializeFiltre();
      this.$refs.filtreListeEcheancePaiement.viderCritere();
      this.$refs.filtreListeEcheancePaiement.appliquerCritere();
      this.showFiltre = false;
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    getEtatEcheance(resteALettrer) {
      if (resteALettrer === 0) return this.$i18n.t('listeEcheancePaiement.paye');
      return this.$i18n.t('listeEcheancePaiement.nonPaye');
    },
    handleAction(action) {
      switch (action) {
        case ACTION_CREER_REMISE_BANCAIRE:
          this.launchPopUpCreationRemiseBancaire(this.getAllEcheancesAPayerSelected());
          break;
        case ACTION_REPLANNIFER:
          this.editEcheanceAReplanifier();
          break;
        default:
          break;
      }
    },
    editEcheanceAReplanifier() {
      this.echeancesAPayerAModifier = this.getAllEcheancesAPayerSelected();
      this.popUpReplanification = true;
    },
    closePopUpAndInformUser() {
      this.popUpReplanification = false;
      snackBarSuccess(
        this.$i18n.t('listeEcheancesAPayer.messages.successEdit'),
        this.$i18n.t('listeEcheancesAPayer.actions.reload'),
        () => {
          this.recherche();
        },
      );
    },
    launchPopUpCreationRemiseBancaire(echeances) {
      this.popUpCreationRemiseBancaire = true;
      this.echeancesAPayerAModifier = echeances;
    },
    closeAndSearch() {
      this.popUpCreationRemiseBancaire = false;
      this.recherche();
    },
    displayOrMasquerEcheanceAnt() {
      this.setDisplayEcheanceAnt(!this.displayEcheancesAnt);
      if (this.displayEcheancesAnt) {
        this.setDatesEcheancesSave(cloneDeep(this.criteresRecherche.datesMouvement));
        this.criteresRecherche.datesMouvement.dateDebut = null;
        this.criteresRecherche.datesMouvement.dateFin = new Date();
      } else this.criteresRecherche.datesMouvement = cloneDeep(this.datesEcheancesSave);
      this.recherche();
    },
  },
  computed: {
    ...EcheancesAPayer.mapGetters({
      criteresRecherche: 'criteresRecherche',
      echeancesAPayer: 'items',
      totalCount: 'total',
      lastPayload: 'lastPayload',
      totalEcheancesBeforeNow: 'totalEcheancesBeforeNow',
      displayEcheancesAnt: 'displayEcheancesAnt',
      datesEcheancesSave: 'datesEcheancesSave',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeEcheancePaiement.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeEcheancePaiement.breadcrumb.liste'), route: { name: 'l.bodac.echeance_payement' }, isActive: true },
      ];
    },
    allEcheancesAPayerSelected() {
      return this.getAllEcheancesAPayerSelected().length === this.echeancesAPayer
        .filter((el) => {
          return el.resteALettrer !== 0;
        }).length;
    },
    iconSelectTotal() {
      if (this.allEcheancesAPayerSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    nombreCritere() {
      const banCritere = ['datesMouvement'];
      let nombreCritere = calculNombreCritere(this.criteresRecherche, banCritere);
      nombreCritere += this.criteresRecherche.paye !== null ? 1 : 0;
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    columns() {
      const columns = ['selected', 'factureCode', 'dateFacture', 'payeur', 'compteComptable', 'dateMouvement', 'montantTTC', 'resteALettrer', 'modeReglementLibelle', 'commercial', 'assistant', 'etat', 'rib.banque', 'iban', 'rib.bic', 'referenceUniqueMandat', 'dateSignatureMandat'];
      if (this.agencesSelectionnees.length > 1) {
        columns.splice(columns.findIndex((column) => column === 'etat'), 0, 'agence');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          factureCode: this.$i18n.t('listeEcheancePaiement.tab.factureCode'),
          dateFacture: this.$i18n.t('listeEcheancePaiement.tab.dateFacture'),
          payeur: this.$i18n.t('listeEcheancePaiement.tab.payeur'),
          compteComptable: this.$i18n.t('listeEcheancePaiement.tab.compteComptable'),
          dateMouvement: this.$i18n.t('listeEcheancePaiement.tab.dateMouvement'),
          montantTTC: this.$i18n.t('listeEcheancePaiement.tab.montantTtc'),
          resteALettrer: this.$i18n.t('listeEcheancePaiement.tab.resteALettrer'),
          modeReglementLibelle: this.$i18n.t('listeEcheancePaiement.tab.modeReglementLibelle'),
          commercial: this.$i18n.t('listeEcheancePaiement.tab.commercial'),
          etat: this.$i18n.t('listeEcheancePaiement.tab.etat'),
          assistant: this.$i18n.t('listeEcheancePaiement.tab.assistant'),
          'rib.banque': this.$i18n.t('listeEcheancePaiement.tab.banque'),
          iban: this.$i18n.t('listeEcheancePaiement.tab.iban'),
          'rib.bic': this.$i18n.t('listeEcheancePaiement.tab.bic'),
          referenceUniqueMandat: this.$i18n.t('listeEcheancePaiement.tab.rum'),
          dateSignatureMandat: this.$i18n.t('listeEcheancePaiement.tab.dateSignatureMandat'),
          agence: this.$i18n.t('listeEcheancePaiement.tab.agence'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          if (this.criteresRecherche.agencesIds.length === 0) {
            data.query.agencesIds = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadEcheancesAPayer(data);
        }),
        columnsClasses: {
          commentaireLigneCommande: 'colonneCommentaire',
          commentaireCommande: 'colonneCommentaire',
          dateEcheance: 'colonneWidth130px',
          edit: 'colonneSelected',
        },
        responseAdapter: (() => {
          return {
            data: this.echeancesAPayer,
            count: this.totalCount,
          };
        }),
        sortable: ['factureCode', 'dateFacture', 'payeur', 'compteComptable', 'dateMouvement', 'montantTTC', 'resteALettrer', 'modeReglementLibelle', 'commercial', 'assistant', 'etat', 'rib.banque', 'rib.iban', 'rib.bic', 'referenceUniqueMandat', 'dateSignatureMandat'],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_ECHEANCES,
        Filtres: this.lastPayload,
      };
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPageAndCheckChangement);
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pageGescom.echeancePaiement.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
